<template>
  <v-dialog v-model="dialogStatus" max-width="1200" transition="dialog-bottom-transition">
    <v-card>
      <!-- 搜索栏  -->
      <v-toolbar color="success">
        <v-toolbar-title class="white--text">
          <!-- <div style="padding-left: 20px">{{ typeMap[type] }}库</div> -->
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-sm-flex justify-between">
          <div class="d-flex ms-auto">
            <div
              style="display: inline-block; margin-top: 10px"
              @mouseenter="mouseenter"
              @mousedown="mouseDown"
            >
              <el-cascader
                size="small"
                placeholder="全部"
                @change="onchange"
                v-model="optionsValue"
                :props="cascaderProps"
                id="coursefilterWrapDev"
                ref="coursefilterWrapDev"
              >
              </el-cascader>
            </div>

            <v-btn class="md-button md-success dropdown-toggle" @click="clearFilter">
              清除筛选
              <md-icon>filter_list_off</md-icon>
            </v-btn>
          </div>
        </div>
      </v-toolbar>
      <v-toolbar flat height="80">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="searchQuery"
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-magnify"
              label="请输入名称"
              single-line
              hide-details
              @keydown="keydownSearch"
            ></v-text-field>
          </template>
          <span>按回车以检索</span>
        </v-tooltip>
      </v-toolbar>
      <div class="max-vh-50 overflow-auto pa-5" style="width: 100%">
        <v-row dense>
          <v-col class="px-1" cols="12" v-show="loading"
            ><v-progress-linear :active="loading" :indeterminate="loading"></v-progress-linear
          ></v-col>
          <v-col cols="10">
            <v-row dense>
              <v-col
                v-for="modelResource in modelResourceList"
                :key="modelResource.id"
                cols="3"
                class="py-1"
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-expand-transition>
                      <v-card
                        hover
                        :class="[`elevation-${hover ? 20 : 2}`, 'mx-2', 'transition-swing']"
                        @click="handleResourcePreview(modelResource)"
                      >
                        <v-img
                          :src="modelResource.model_image"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          height="200px"
                        >
                          <v-card-title v-text="modelResource.model_name"></v-card-title>
                        </v-img>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            :color="!chooseModelMap[modelResource._id] ? 'success' : 'error'"
                            text
                            small
                            @click="choose(modelResource)"
                            >{{ !chooseModelMap[modelResource._id] ? '选择' : '取消选择' }}</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-expand-transition>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="12">
                <Pagination
                  :page.sync="pagination.page"
                  :total="pagination.total"
                  :itemsSelect="[4, 8, 20, 40]"
                  :items-per-page.sync="pagination.itemsPerPage"
                  @refresh="refreshResourceList"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-divider vertical></v-divider>
          <v-col cols="2">
            <v-list dense>
              <v-subheader>选择的模型</v-subheader>
              <v-list-item-group color="success">
                <v-list-item v-for="(item, i) in chooseModelArr" :key="i">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.model_name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn small icon color="error" @click.stop="choose(item)">
                      <!-- <v-icon small>mdi-close</v-icon> -->
                      <span
                        class="iconfont icon-shanchu2"
                        style="font-size: 16px; color: rgb(255, 82, 82)"
                      ></span>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </div>
      <div class="py-4 px-4 text-right">
        <v-spacer></v-spacer>
        <v-btn color="success" dark @click.stop="confirmChooseModel" :disabled="isDisabled"
          >确认</v-btn
        >
        <v-btn class="ml-2" color="gray" @click.stop="dialogStatus = false">取消</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Pagination from '@/components/Pagination/index';
import { refreshResourceList, saveProjectModelResource } from '@/api/model_resource';
import { mapGetters } from 'vuex';
4;
import { categoryList } from '../../../api/user';
import { getCourseById } from '@/api/course';

export default {
  name: 'EditorModelChoose',
  components: {
    Pagination,
  },
  props: {
    courseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDisabled: false,
      chooseModelArr: [],
      chooseModelMap: {},
      // 选中的模型id
      model_id: '',
      // 模型展示弹框控制
      previewModelStatus: false,
      // 搜索条件
      searchQuery: '',
      // 加载
      loading: true,
      // 查询参数
      // queryParams: [
      //     {
      //         level: 'Level_1',
      //         value: 0,
      //         code: '',
      //         title: '专业分类',
      //         listData: [],
      //         disabled: false
      //     },
      // ],
      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 4,
        total: 0,
      },
      showDetailDialog: false,
      showNewDialog: false,
      checkList: [],
      selectedItem: {},
      modelResourceList: [],
      selectedResource: {},
      typeList: [
        {
          name: '设备',
          type: 'device',
        },
        {
          name: '角色',
          type: 'role',
        },
        {
          name: '工具',
          type: 'tool',
        },
        {
          name: '场景',
          type: 'scene',
        },
      ],
      tooltipValue: '全部',
      tooltipVisible: false,
      optionsValue: ['all'],
      cascaderProps: {
        label: 'name',
        value: 'code',
        lazy: true,
        lazyLoad: (node, resolve) => {
          let that = this;
          const { level } = node;

          setTimeout(() => {
            if (node.level == 0) {
              let options = [
                {
                  name: '全部',
                  code: 'all',
                  level: 0,
                },
                {
                  name: '设备',
                  code: 'device',
                  level: 0,
                },
                {
                  name: '角色',
                  code: 'role',
                  level: 0,
                },
                {
                  name: '工具',
                  code: 'tool',
                  level: 0,
                },
                {
                  name: '场景',
                  code: 'scene',
                  level: 0,
                },
              ];
              resolve(options);
            }
            if (node.level == 1) {
              if (node.value == '') {
                return;
              }
              let params = {
                cate_type: node.value || '',
                level: '1',
                parentCode: '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data.unshift({
                    name: '全部',
                    code: '-1',
                  });
                  res.data.forEach(item => {
                    item.leaf = true;
                  });
                  resolve(res.data);
                }
              });
            }
            if (node.level == 2) {
              // let params = {
              //   cate_type: node.parent.value || '',
              //   level: '2',
              //   parentCode: node.value || '',
              // };
              // categoryList(params).then(res => {
              //   if (res.data) {
              //     res.data.forEach(item => {
              //       item.leaf = true;
              //     });
              //     resolve(res.data);
              //   }
              // });
            } else if (node.level > 2) {
              resolve([]);
            }
          }, 100);
        },
      },
      // typeMap: {},
      type: 'device',
    };
  },
  computed: {
    ...mapGetters(['project', 'chooseModelList']),
    dialogStatus: {
      get() {
        return this.$store.state.editor.showOpenModelChoose;
      },
      set(val) {
        this.$store.dispatch('editor/reverseShowOpenModelChoose', val);
      },
    },
  },
  watch: {
    chooseModelList(val) {
      this.chooseModelArr = val.map(item => {
        const { modelId, modelName, modelAmrtUrl } = item;
        return {
          _id: modelId,
          model_name: modelName,
          model_amrt_file_list_json: modelAmrtUrl,
        };
      });
      this.chooseModelMap = this.chooseModelArr.reduce((map, model) => {
        map[model._id] = true;
        return map;
      }, {});
    },
  },
  created() {
    // this.typeMap = this.typeList.reduce((pre, next) => {
    //     pre[next.type] = next.name;
    //     return pre;
    // }, {})
    this.refreshResourceList();
    // this.initDict('device')
  },
  mounted() {
    // coursefilterWrapDev.children[0].children[0].style.cssText=`border: none;
    // background: #4caf50 !important;
    // color: #fff;
    // font-weight: 700;`
    // this.setCard();

    this.queryCourse();
  },
  methods: {
    getUserId() {
      let userId = '';
      if (window.localStorage.getItem('USER_INFO')) {
        let data = JSON.parse(window.localStorage.getItem('USER_INFO'));
        userId = data.user._id;
      } else {
        userId = '';
      }
      return userId;
    },
    queryCourse() {
      if (this.$route.params.courseId) {
        getCourseById(this.$route.params.courseId).then(res => {
          // if(this.getUserId()==res.data.createUserId){  //自己创建的课程公开 和不公开
          //   this.isDisabled = false

          // }else{  //不是自己创建的课程公开和不公开
          //   this.isDisabled = true

          // }

          if (res.data) {
            if (res.data.hasAuthModify) {
              //自己创建的课程和协作课程 true 可以修改并且查看
              this.isDisabled = false;
            } else {
              //不是自己创建的课程 如果是普通模式//禁用
              this.isDisabled = true;
            }
          }
        });
      }
    },
    onchange(data) {
      this.pagination.page = 1;

      //    this.pagination.itemsPerPage,
      this.refreshResourceList();
    },
    setCard() {
      let getNode = document.querySelector('.el-cascader .el-input__inner');
      let str = '';

      if (this.$refs.coursefilterWrapDev.getCheckedNodes()[0] == null) {
        getNode.style.width = 80 + 'px';
      } else {
        this.$refs.coursefilterWrapDev.getCheckedNodes()[0].pathLabels.forEach(item => {
          str += item;
        });
        if (str.indexOf('全部') !== -1) {
          getNode.style.width = str.length * 17 + 60 + 'px';
          return;
        }
        getNode.style.width = str.length * 17 + 60 + 'px';
      }
    },
    mouseenter() {
      let nodes = this.$refs['coursefilterWrapDev'].getCheckedNodes()[0].pathLabels;
      if (this.$refs['coursefilterWrapDev'].getCheckedNodes()[0].value == 'all') {
        this.tooltipVisible = true;
        this.tooltipValue = '全部';
      } else {
        let toopValue = '';
        if (nodes[0]) {
          toopValue = nodes[0];
          if (nodes[1]) {
            toopValue = nodes[0] + '/' + nodes[1];
            if (nodes[2]) {
              toopValue = nodes[0] + '/' + nodes[1] + '/' + nodes[2];
            }
          }
        }
        this.tooltipValue = toopValue;
      }
    },
    mouseDown() {
      this.tooltipVisible = false;
    },
    /**
     * 模型展示
     */
    handleResourcePreview(model) {
      this.model_id = model._id;
      this.previewModelStatus = true;
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.page = 1;
        this.refreshResourceList();
      }
    },
    /**
     * 查看详情
     */
    handleResourceDetail(item) {
      this.showDetailDialog = true;
      this.selectedResource = item;
    },
    /**
     * 清除筛选
     */
    clearFilter() {
      this.searchQuery = '';
      this.queryParams.forEach(item => {
        item.value = 0;
        item.code = '';
      });
      this.refreshResourceList();
    },
    refreshResourceList() {
      let tempData1 = {
        model_name: this.searchQuery || '',
        // one_level_classify: this.queryParams[0].code,
        one_level_classify: this.optionsValue[1] || '',
        page_no: this.pagination.page || '',
        status: '7',
        page_size: this.pagination.itemsPerPage,
        // model_resource_category: this.type,
        model_resource_category: this.optionsValue[0] || '',
      };
      this.loading = true;
      refreshResourceList(tempData1).then(res => {
        this.modelResourceList = res.data.items;
        this.pagination.total = res.data.total;
        this.loading = false;
      });
    },
    chooseType({ type }) {
      this.type = type;
      this.initDict(type);
      this.refreshResourceList();
    },
    choose(model) {
      if (this.isDisabled == true) {
        this.$store.dispatch('global/showWarningMsg', '公开课程禁止操作');
        return;
      }

      if (!model.model_amrt_file_list_json) {
        this.$store.dispatch('global/showWarningMsg', '模型尚未转换无法选择');
        return;
      }
      const model_id = model._id;
      if (this.chooseModelMap[model_id]) {
        const modelIndex = this.chooseModelArr.findIndex(mod => mod._id === model_id);
        this.chooseModelArr.splice(modelIndex, 1);
        delete this.chooseModelMap[model_id];
      } else {
        this.chooseModelArr.unshift(model);
        this.chooseModelMap[model_id] = model;
      }
    },
    confirmChooseModel() {
      const saveModelList = this.chooseModelArr.map(item => {
        return {
          modelId: item._id,
          modelName: item.model_name,
          modelPath: item.model_amrt_file_list_json,
        };
      });
      saveProjectModelResource({
        courseId: this.courseId,
        modelList: saveModelList,
      }).then(res => {
        this.dialogStatus = false;
        this.$store.dispatch('global/showSuccessMsg', '保存成功');
        this.$emit('finish');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}

.v-List-actived {
  background: #ddd;
}

.v-application .indigo--text {
  background: #fff;
}

.disable-color {
  color: #ddd !important;

  i {
    color: #ddd !important;
  }
}

.el-cascader-menu {
  max-width: 250px;
}
.guJiaWrap {
  margin: 5px 0;
}
.el-cascader-panel {
  background: #000 !important;
}
.el-cascader_dropdown {
  border: none;
}
// >>> .el-cascader .el-input .el-input__inner:focus,>>> .el-cascader .el-input.is-focus .el-input__inner{
//   border-color: #de6f6f
// }

/* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
//   .el-cascader{
//       background: red !important;
//   }
//   .el-cascader  .el-input{
//       background: red !important;
//   }

//    #coursefilterWrapDev >>> .el-input:hover {

//     box-shadow: 0 0 6px 1px #70707052;
//     border-radius: 4px;
//       background: red !important;
//   }
//    #coursefilterWrapDev >>> .el-input .el-input__inner {
//     border: none;
//     background: #4caf50 !important;
//     color: #fff;
//     font-weight: 700;
//   }
//   #coursefilterWrapDev >>> .el-input .el-input__inner::placeholder {
//     color: #fff;
//   }
//   #coursefilterWrapDev >>> .el-input .el-input__suffix {
//     color: #fff;
//   }
</style>
